/**
 * Categories adapter — maps NestJS /v1/categories to the flat shape
 * FeaturedCategories.jsx expects: { slug, name, image, product_count }.
 */
import { api } from "@/lib/api";

function pickImage(c) {
  if (typeof c?.imageUrl === "string" && c.imageUrl) return c.imageUrl;
  if (typeof c?.image === "string" && c.image) return c.image;
  if (Array.isArray(c?.media) && c.media[0]?.url) return c.media[0].url;
  if (typeof c?.icon === "string" && c.icon) return c.icon;
  return "https://images.pexels.com/photos/3845625/pexels-photo-3845625.jpeg?auto=compress&cs=tinysrgb&w=400";
}

export function normalizeCategory(raw) {
  if (!raw) return null;
  return {
    id: raw.id || raw.slug,
    slug: raw.slug,
    name: raw.name || raw.title || raw.slug,
    image: pickImage(raw),
    product_count: Number(raw.productCount ?? raw.product_count ?? 0),
    parentId: raw.parentId || null,
  };
}

export async function listCategories(params = {}) {
  const { data } = await api.get("/categories", { params });
  const arr = Array.isArray(data) ? data : data.items || [];
  return arr.map(normalizeCategory).filter(Boolean);
}
